import React, { useEffect, useState } from "react";
import { PageHero, CtaBanner } from "@/components/PageParts";
import { api } from "@/lib/api";

export default function Gallery() {
  const [films, setFilms] = useState([]);
  const [activeCat, setActiveCat] = useState("all");
  useEffect(() => { api.get("/content/films").then((r) => setFilms(r.data || [])); }, []);
  const cats = [{ v: "all", l: "All" }, { v: "legacy", l: "Legacy" }, { v: "family_history", l: "Family History" }, { v: "funeral", l: "Funeral" }];
  const filtered = activeCat === "all" ? films : films.filter((f) => f.category === activeCat);
  return (
    <div data-testid="page-gallery">
      <PageHero
        eyebrow="Watch Our Films"
        title="A quiet portfolio of stories, softly told."
        image="https://images.pexels.com/photos/7854107/pexels-photo-7854107.jpeg"
        testid="gallery-hero"
      />
      <section className="section-pad bg-offwhite">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-wrap justify-center gap-3 mb-14">
            {cats.map((c) => (
              <button key={c.v} onClick={() => setActiveCat(c.v)}
                data-testid={`filter-${c.v}`}
                className={`px-6 py-2 rounded-full text-sm uppercase tracking-widest transition-all ${activeCat === c.v ? "bg-primary text-white" : "bg-white border border-border-warm text-warmgrey hover:border-primary"}`}>
                {c.l}
              </button>
            ))}
          </div>
          <div className="grid md:grid-cols-2 gap-10">
            {filtered.map((f) => (
              <div key={f.id} className="bg-white rounded-xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.06)]" data-testid={`gallery-item-${f.id}`}>
                <video className="w-full aspect-video object-cover" controls poster={f.thumbnail_url}>
                  <source src={f.video_url} type="video/mp4" />
                </video>
                <div className="p-6">
                  <h3 className="font-serif text-xl mb-2">{f.title}</h3>
                  <p className="text-warmgrey text-sm">{f.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner title="Tell us about the person we should film next." testid="gallery-cta" />
    </div>
  );
}
